module.exports = __webpack_public_path__ + "img/Logo trasparente white.d0249f16.png";